import ReservationUtils from 'utils/reservation-utils';
export default function getReservationStatus({ activeStatus, paymentStatus, }) {
    if (paymentStatus === ReservationUtils.PAYMENT_STATUSES.REFUND) {
        return 'cancelled';
    }
    else if (activeStatus === ReservationUtils.ACTIVE_STATUS.NOT_STARTED) {
        return 'upcoming';
    }
    else if (activeStatus === ReservationUtils.ACTIVE_STATUS.ENDED) {
        return 'past';
    }
    else if (activeStatus === ReservationUtils.ACTIVE_STATUS.ACTIVE) {
        return 'active';
    }
    else {
        return null;
    }
}
